import React from 'react';
import PropTypes from 'prop-types';
import { SEPARATOR } from '../../modules/constants';

const COMPONENT_CLASS_NAME = 'divider';

/**
 * Divider line used in the main menu and footer components
 *
 * @function
 * @param       {[string]} className additional className which can be set in the data.
 * @constructor
 */
function Divider({ className }) {
    return (
        <div
            role={SEPARATOR}
            className={[className, COMPONENT_CLASS_NAME].join(' ').trim()}
        />
    );
}

Divider.propTypes = {
    className: PropTypes.string
};

export { Divider };
